// extracted by mini-css-extract-plugin
export default {"tutorialBG":"TutorialStyles_tutorialBG__SUDLP","show":"TutorialStyles_show__G7wNn","tutorial":"TutorialStyles_tutorial__EG8QY","skipCount":"TutorialStyles_skipCount__9qf+S"};